webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(105);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(104);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueClap = __webpack_require__(93);
	
	var _vueClap2 = _interopRequireDefault(_vueClap);
	
	var _App = __webpack_require__(99);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _ListFiles = __webpack_require__(102);
	
	var _ListFiles2 = _interopRequireDefault(_ListFiles);
	
	var _TimeLog = __webpack_require__(103);
	
	var _TimeLog2 = _interopRequireDefault(_TimeLog);
	
	var _CreateTimeLog = __webpack_require__(100);
	
	var _CreateTimeLog2 = _interopRequireDefault(_CreateTimeLog);
	
	var _goog = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueClap2.default);
	var router = new _vueRouter2.default();
	router.map({
	  '': {
	    component: _ListFiles2.default
	  },
	  '/time-log/:sheetId': {
	    component: _TimeLog2.default
	  },
	  '/create-time-log': {
	    component: _CreateTimeLog2.default
	  }
	});
	
	router.start(_App2.default, '#app');
	
	(0, _goog.initializeGoogleApi)();

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(51);
	
	var _map2 = _interopRequireDefault(_map);
	
	exports.signIn = signIn;
	exports.signOut = signOut;
	exports.fetchLastRecords = fetchLastRecords;
	exports.logTime = logTime;
	exports.createSpreadsheet = createSpreadsheet;
	exports.initializeGoogleApi = initializeGoogleApi;
	exports.getError = getError;
	exports.getSheetTitle = getSheetTitle;
	
	var _appModel = __webpack_require__(14);
	
	var _appModel2 = _interopRequireDefault(_appModel);
	
	var _logTemplate = __webpack_require__(45);
	
	var _logTemplate2 = _interopRequireDefault(_logTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLIENT_ID = '616901175953-k3qnrg34f7khs5a688k8l51oqn4f15o1.apps.googleusercontent.com';
	
	var TIME_RANGE = 'A2:C';
	
	var SCOPES = ['https://www.googleapis.com/auth/drive', 'https://www.googleapis.com/auth/spreadsheets'];
	
	var sheetIdToTitle = new _map2.default();
	
	var apiInitialized = false;
	
	function signIn(immediate) {
	  return gapi.auth.authorize({
	    client_id: CLIENT_ID,
	    scope: SCOPES,
	    immediate: immediate
	  }, handleAuthResult);
	}
	
	function signOut(callback) {
	  var token = gapi.auth.getToken();
	  if (token) {
	    var accessToken = token.access_token;
	    var revokeUrl = 'https://accounts.google.com/o/oauth2/revoke?token=' + accessToken;
	
	    window.jQuery.ajax({
	      type: 'GET',
	      url: revokeUrl,
	      async: false,
	      contentType: 'application/json',
	      dataType: 'jsonp',
	      success: forwardCallback,
	      error: forwardCallback
	    });
	  }
	
	  gapi.auth.signOut();
	
	  if (!token) setTimeout(forwardCallback, 0);
	
	  function forwardCallback() {
	    cleanAppModel();
	    callback();
	  }
	}
	
	function cleanAppModel() {
	  _appModel2.default.filesLoaded = false;
	  _appModel2.default.files = [];
	  _appModel2.default.authenticated = undefined;
	}
	
	function fetchLastRecords(spreadsheetId) {
	  return gapi.client.sheets.spreadsheets.values.get({
	    spreadsheetId: spreadsheetId,
	    range: TIME_RANGE
	  }).then(id, checkError);
	}
	
	function logTime(spreadsheetId, start, end, what) {
	  return gapi.client.sheets.spreadsheets.values.append({
	    spreadsheetId: spreadsheetId,
	    valueInputOption: 'USER_ENTERED',
	    range: TIME_RANGE,
	    values: [[start, end, what]]
	  }).then(id, checkError);
	}
	
	function createSpreadsheet(name) {
	  return gapi.client.sheets.spreadsheets.create((0, _logTemplate2.default)(name)).then(function (response) {
	    var result = response.result;
	
	    _appModel2.default.files.unshift({
	      id: result.spreadsheetId,
	      name: name
	    });
	
	    return result;
	  }, checkError);
	}
	
	function initializeGoogleApi() {
	  if (!gapi.auth) {
	    window.initializeGoogleApi = initializeGoogleApi;
	
	    return;
	  }
	
	  if (apiInitialized) {
	    return;
	  }
	
	  apiInitialized = true;
	
	  signIn(true);
	}
	
	function getError(response) {
	  if (!response) throw new Error('Response is required here');
	
	  if (response.result && response.result.error) {
	    return response.result.error.message;
	  }
	
	  return 'Unknown error :(';
	}
	
	function getSheetTitle(spreadsheetId, callback) {
	  if (sheetIdToTitle.has(spreadsheetId)) {
	    var title = sheetIdToTitle.get(spreadsheetId);
	    setTimeout(function () {
	      return callback(title);
	    }, 0);
	    return;
	  }
	
	  gapi.client.sheets.spreadsheets.get({
	    spreadsheetId: spreadsheetId,
	    fields: 'properties/title'
	  }).then(function (response) {
	    var title = get(response, 'result.properties.title');
	    sheetIdToTitle.set(spreadsheetId, title);
	    callback(title);
	  });
	}
	
	function handleAuthResult(authResult) {
	  _appModel2.default.authenticated = authResult && !authResult.error;
	
	  if (_appModel2.default.authenticated) loadAPIs();
	}
	
	function loadAPIs() {
	  gapi.client.load('https://sheets.googleapis.com/$discovery/rest?version=v4').then(markGapiReady);
	  gapi.client.load('drive', 'v3', listTimeSheetFiles);
	}
	
	function markGapiReady() {
	  _appModel2.default.sheetsAPIReady = true;
	}
	
	function listTimeSheetFiles() {
	  gapi.client.drive.files.list({
	    q: "mimeType='application/vnd.google-apps.spreadsheet' and trashed = false",
	    pageSize: 100
	  }).execute(function (response) {
	    _appModel2.default.filesLoaded = true;
	    _appModel2.default.files = response.files;
	    makeTitleIndex(response.files);
	  }, checkError);
	}
	
	function makeTitleIndex(files) {
	  files.forEach(function (file) {
	    sheetIdToTitle.set(file.id, file.name);
	  });
	}
	
	function get(obj, path) {
	  if (!obj) return obj;
	
	  var parts = path.split('.');
	  for (var i = 0; i < parts.length; ++i) {
	    var key = parts[i];
	    obj = obj[key];
	    if (!obj) return obj;
	  }
	
	  return obj;
	}
	
	function id(x) {
	  return x;
	}
	
	function checkError(response) {
	  if (response.status === 401) {
	    window.location.reload();
	  }
	
	  return response;
	}

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var appModel = {
	  authenticated: undefined,
	  sheetsAPIReady: false,
	  filesLoaded: false,
	  files: [],
	
	  pageName: ''
	};
	
	exports.default = appModel;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertDateToSheetsDateString = convertDateToSheetsDateString;
	exports.getNow = getNow;
	exports.toDateInputStr = toDateInputStr;
	function convertDateToSheetsDateString(str) {
	  var dateObject = new Date(str + 'Z');
	
	  return dateObject.toISOString().substr(0, '2016-09-27T02:10:00'.length).replace(/T/, ' ').replace(/-/g, '/');
	}
	
	function getNow() {
	  return toDateInputStr(new Date());
	}
	
	function toDateInputStr(date) {
	  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
	}
	
	function pad(number) {
	  if (number < 10) {
	    return '0' + number;
	  }
	  return number;
	}

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSpreadsheetIdFromComponentRoute;
	function getSpreadsheetIdFromComponentRoute(component) {
	  return component.$route.params.sheetId;
	}

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(52);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	exports.default = getLastRecordsForComponent;
	
	var _getSpreadsheetIdFromComponentRoute = __webpack_require__(27);
	
	var _getSpreadsheetIdFromComponentRoute2 = _interopRequireDefault(_getSpreadsheetIdFromComponentRoute);
	
	var _dateUtils = __webpack_require__(17);
	
	var _goog = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLastRecordsForComponent(component) {
	  component.recordsState = 'loading';
	
	  var spreadsheetId = (0, _getSpreadsheetIdFromComponentRoute2.default)(component);
	
	  return (0, _goog.fetchLastRecords)(spreadsheetId).then(function (response) {
	    component.recordsState = 'loaded';
	
	    var values = response.result.values || [];
	    var lastRecords = values.reverse().slice(0, 100);
	
	    component.lastRecords = lastRecords;
	    var lastDate = getLastDate(lastRecords);
	    if (lastDate) component.start = lastDate;else {
	      component.start = (0, _dateUtils.getNow)();
	      component.end = (0, _dateUtils.getNow)();
	    }
	  }, function (response) {
	    console.error('failed to load range', response);
	  });
	}
	
	function getLastDate(records) {
	  if (records.length === 0) return '';
	
	  var lastRecord = records[0];
	  if (lastRecord.length < 2) return '';
	
	  var lastEnd = lastRecord[1];
	
	  if (!lastEnd) return '';
	
	  var d = new Date(lastEnd);
	  if ((0, _isNan2.default)(d.getDate())) return '';
	
	  return (0, _dateUtils.toDateInputStr)(d);
	}

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDateInputSupported;
	
	var dateInputSupported = undefined;
	
	function isDateInputSupported() {
	  if (dateInputSupported !== undefined) return dateInputSupported;
	
	  dateInputSupported = checkDateInput();
	
	  return dateInputSupported;
	}
	
	function checkDateInput() {
	  var input = document.createElement('input');
	  input.setAttribute('type', 'datetime-local');
	
	  var notADateValue = 'not-a-date';
	  input.setAttribute('value', notADateValue);
	
	  return input.value !== notADateValue;
	}

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createLogTemplate;
	function createLogTemplate(name) {
	  return {
	    properties: {
	      title: '' + name
	    },
	    sheets: createTimeSheet('Time Log')
	  };
	}
	
	function createTimeSheet(title) {
	  return {
	    properties: {
	      title: title,
	      gridProperties: {
	        frozenRowCount: 1,
	
	        frozenColumnCount: 3
	      }
	    },
	    data: [createHeaderRow()]
	  };
	}
	
	function createHeaderRow() {
	  return {
	    startRow: 0,
	    startColumn: 0,
	    rowData: {
	      values: [header('Start'), header('End'), header('What?')]
	    }
	  };
	}
	
	function header(text) {
	  return {
	    userEnteredValue: {
	      stringValue: text
	    },
	    userEnteredFormat: {
	      horizontalAlignment: 'CENTER',
	      textFormat: {
	        bold: true
	      }
	    }
	  };
	}

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appModel = __webpack_require__(14);
	
	var _appModel2 = _interopRequireDefault(_appModel);
	
	var _goog = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  ready: function ready() {
	    $('.button-collapse').sideNav();
	  },
	  data: function data() {
	    return _appModel2.default;
	  },
	
	
	  methods: {
	    onSignInClick: function onSignInClick() {
	      (0, _goog.signIn)();
	    },
	    onSignOutClick: function onSignOutClick() {
	      (0, _goog.signOut)(function () {
	        return window.location.reload();
	      });
	    }
	  },
	
	  computed: {
	    unknown: function unknown() {
	      return _appModel2.default.authenticated === undefined;
	    },
	    apiLoaded: function apiLoaded() {
	      return _appModel2.default.authenticated && _appModel2.default.sheetsAPIReady;
	    },
	    needsAuthentication: function needsAuthentication() {
	      return _appModel2.default.authenticated === false;
	    }
	  }
	};

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _goog = __webpack_require__(9);
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '',
	      status: '',
	      error: ''
	    };
	  },
	
	
	  methods: {
	    create: function create() {
	      var _this = this;
	
	      this.status = 'saving';
	      (0, _goog.createSpreadsheet)(this.name).then(function (result) {
	        _this.status = '';
	        var spreadsheetId = result.spreadsheetId;
	
	        _this.$router.go('/time-log/' + spreadsheetId);
	      }, function (response) {
	        _this.error = (0, _goog.getError)(response);
	      });
	    }
	  }
	};

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _flatpickr = __webpack_require__(92);
	
	var _flatpickr2 = _interopRequireDefault(_flatpickr);
	
	var _dateUtils = __webpack_require__(17);
	
	var _isDateInputSupported = __webpack_require__(44);
	
	var _isDateInputSupported2 = _interopRequireDefault(_isDateInputSupported);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['label', 'value'],
	
	  ready: function ready() {
	    var self = this;
	    var pickerConfig = {
	      allowInput: true,
	      enableTime: true,
	      time_24hr: true,
	      enableSeconds: true,
	      dateFormat: 'Y-m-dTH:i:S',
	      utc: false,
	
	      onChange: function onChange() {
	        self.changeFromFlatPickr = true;
	      }
	    };
	
	    this.flatPickr = (0, _isDateInputSupported2.default)() ? zeropickr() : new _flatpickr2.default(this.$els.date, pickerConfig);
	  },
	  detached: function detached() {
	    this.flatPickr.destroy();
	  },
	
	
	  methods: {
	    setNow: function setNow() {
	      this.value = (0, _dateUtils.getNow)();
	    }
	  },
	
	  watch: {
	    value: function value(newValue) {
	      if (this.changeFromFlatPickr) {
	        this.changeFromFlatPickr = false;
	      } else {
	        this.flatPickr.setDate(newValue);
	      }
	    }
	  }
	};
	
	function zeropickr() {
	  return {
	    setDate: noop,
	    destroy: noop
	  };
	
	  function noop() {}
	}

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appModel = __webpack_require__(14);
	
	var _appModel2 = _interopRequireDefault(_appModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return _appModel2.default;
	  },
	
	  route: {
	    data: function data() {
	      _appModel2.default.pageName = 'Select Sheet';
	    }
	  },
	
	  computed: {
	    empty: function empty() {
	      return _appModel2.default.files.length === 0 && _appModel2.default.filesLoaded;
	    }
	  }
	};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appModel = __webpack_require__(14);
	
	var _appModel2 = _interopRequireDefault(_appModel);
	
	var _goog = __webpack_require__(9);
	
	var _dateUtils = __webpack_require__(17);
	
	var _getLastRecordsForComponent = __webpack_require__(43);
	
	var _getLastRecordsForComponent2 = _interopRequireDefault(_getLastRecordsForComponent);
	
	var _getSpreadsheetIdFromComponentRoute = __webpack_require__(27);
	
	var _getSpreadsheetIdFromComponentRoute2 = _interopRequireDefault(_getSpreadsheetIdFromComponentRoute);
	
	var _DateTime = __webpack_require__(101);
	
	var _DateTime2 = _interopRequireDefault(_DateTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      recordsState: 'loading',
	      lastRecords: [],
	      start: '',
	      end: (0, _dateUtils.getNow)(),
	      what: '',
	      saveState: ''
	    };
	  },
	
	  computed: {
	    editLink: function editLink() {
	      var sheetId = (0, _getSpreadsheetIdFromComponentRoute2.default)(this);
	      return 'https://docs.google.com/spreadsheets/d/' + sheetId + '/edit';
	    }
	  },
	  components: {
	    DateTime: _DateTime2.default
	  },
	  route: {
	    data: function data() {
	      var _this = this;
	
	      _appModel2.default.pageName = 'Loading data...';
	
	      (0, _getLastRecordsForComponent2.default)(this).then(function () {
	        var sheetId = (0, _getSpreadsheetIdFromComponentRoute2.default)(_this);
	        (0, _goog.getSheetTitle)(sheetId, function (title) {
	          _appModel2.default.pageName = title;
	        });
	      });
	    }
	  },
	
	  methods: {
	    refreshRecords: function refreshRecords() {
	      (0, _getLastRecordsForComponent2.default)(this);
	    },
	    logIt: function logIt() {
	      var _this2 = this;
	
	      this.saveState = 'saving';
	
	      var start = (0, _dateUtils.convertDateToSheetsDateString)(this.start);
	      var end = (0, _dateUtils.convertDateToSheetsDateString)(this.end);
	      var spreadsheetId = (0, _getSpreadsheetIdFromComponentRoute2.default)(this);
	
	      (0, _goog.logTime)(spreadsheetId, start, end, this.what).then(function () {
	        _this2.lastRecords.unshift([start, end, _this2.what]);
	        _this2.start = _this2.end;
	        _this2.end = (0, _dateUtils.getNow)();
	
	        _this2.what = '';
	        _this2.saveState = 'done';
	        _this2.error = '';
	      }, function (response) {
	        _this2.saveState = 'error';
	        _this2.error = (0, _goog.getError)(response);
	      });
	    }
	  }
	};

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	module.exports = " <div> <div class=navbar-fixed> <nav> <div class=nav-wrapper> <a href=# class=brand-logo>{{pageName}}</a> <a href=# data-activates=mobile-demo class=button-collapse><i class=material-icons>menu</i></a> <ul id=nav-mobile class=\"right hide-on-med-and-down\"> <li v-if=authenticated><a href=# @click.prevent=onSignOutClick>Sign out</a></li> <li><a href=https://github.com/anvaka/time>Source code</a></li> </ul> <ul class=side-nav id=mobile-demo> <li v-if=authenticated><a href=# @click.prevent=onSignOutClick>Sign out</a></li> <li><a href=https://github.com/anvaka/time>Source code</a></li> </ul> </div> </nav> </div> <div class=container> <div v-if=unknown> <h3>Checking authentication...<h3> </h3></h3></div> <div v-if=apiLoaded> <router-view class=view keep-alive></router-view> </div> <div v-if=needsAuthentication> <h1>Welcome!</h1> <p> This is a simple interface to Google Sheets, that allows you to log your time. Log it here, and analyze from Google Sheets later </p> <a class=\"waves-effect waves-light btn\" @click=onSignInClick>Sign in to Google Sheets</a> <div> <h4>Demo</h4> <iframe src=https://www.youtube.com/embed/5e8K0LMdTmw frameborder=0 allowfullscreen class=video-demo></iframe> </div> </div> </div> </div> ";

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	module.exports = " <div> <h3>Create new time log</h3> <form @submit.prevent=create> <div class=input-field> <label for=name>File name:</label> <input id=name type=text v-model=name autofocus> </div> <input type=submit class=\"waves-effect waves-light btn col s12\" value=\"Create new file\" v-if='status === \"\"'/> </form> <div v-if='status === \"saving\"'> <h4>Saving {{name}}...</h4> <div class=progress> <div class=indeterminate></div> </div> </div> <div v-if=error class=\"card-panel red-text\"> <h4>Error...</h4> <pre><code>{{error}}</code></pre> <div> Refresh the page maybe? </div> </div> </div> ";

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	module.exports = " <div> <label>{{label}} <a href=# v-clap.prevent=setNow()>set to now</a></label> <input v-el:date type=datetime-local v-model=value data-input> </div> ";

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	module.exports = " <div> <div v-if=empty> <h3>No time sheets?</h3> <p>I could not find any time logs in your account. <a v-link=\"{path: '/create-time-log'}\">Create new time log</a>. </p> </div> <div v-if=\"filesLoaded && !empty\"> <h4>Your Sheets</h4> <div class=collection> <a class=collection-item v-for=\"file in files\" v-link=\"{path: '/time-log/' + file.id}\">{{file.name}}</a> </div> <div class=fixed-action-btn> <a class=\"btn-floating btn-small red\" v-link=\"{path: '/create-time-log'}\" title=\"Create new time log\"> <i class=\"small material-icons\">add</i> </a> </div> </div> </div> ";

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	module.exports = " <div> <form novalidate @submit.prevent=logIt> <date-time label=Start :value.sync=start></date-time> <date-time label=End :value.sync=end></date-time> <div class=input-field> <label for=what>What?</label> <input id=what type=text v-model=what> </div> <div class=row v-if='saveState !== \"saving\"'> <input type=submit class=\"waves-effect waves-light btn col s12\" value=\"Log time\"/> </div> </form> <div v-if='saveState === \"saving\"'> <h4>Saving...</h4> <div class=progress> <div class=indeterminate></div> </div> </div> <div v-if='saveState === \"error\"' class=\"card-panel red-text\"> <h4>Error...</h4> <pre><code>{{error}}</code></pre> <div> Refresh the page maybe? </div> </div> <div v-if='recordsState === \"loaded\"'> <table> <thead> <tr> <th data-field=start>Start</th> <th data-field=end>End</th> <th data-field=what> What? <a href=# @click.prevent=refreshRecords class=right title=refresh>&#x21bb;</a> </th> </tr> </thead> <tbody> <tr v-for=\"record in lastRecords\"> <td>{{record[0]}}</td> <td>{{record[1]}}</td> <td>{{record[2]}}</td> </tr> </tbody> </table> <div class=fixed-action-btn style=\"bottom: 12px; right: 12px\"> <a class=\"btn-floating btn-small red\" :href=editLink title=\"Edit records...\" target=_blank> <i class=\"small material-icons\">mode_edit</i> </a> </div> </div> <div v-if='recordsState === \"loading\"'> <h4>Loading records...</h4> <div class=progress> <div class=indeterminate></div> </div> </div> </div> ";

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(91)
	__vue_script__ = __webpack_require__(46)
	__vue_template__ = __webpack_require__(94)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(47)
	__vue_template__ = __webpack_require__(95)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(48)
	__vue_template__ = __webpack_require__(96)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(49)
	__vue_template__ = __webpack_require__(97)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(50)
	__vue_template__ = __webpack_require__(98)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })

});


// WEBPACK FOOTER //
// static/js/app.4bd7c65b18a85ba40e54.js